import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, OfficialDailyReducer, OfficialDailyState } from './official-daily-reducer';


const OfficialDailyContext = createContext<OfficialDailyState | undefined>(undefined);
const OfficialDailyContextDispatchContext = createContext({} as any);

const OfficialDailyProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(OfficialDailyReducer, {} as OfficialDailyState);

    return (
        <OfficialDailyContext.Provider value={state}>
            <OfficialDailyContextDispatchContext.Provider value={dispatch}>
                {children}
            </OfficialDailyContextDispatchContext.Provider>
        </OfficialDailyContext.Provider>
    );
}

const useOfficialDailyState = () => {
    const context = useContext(OfficialDailyContext);
    if (context === undefined) {
        throw new Error('useHomeState must be used within a HomeProvider');
    }
    return context;
}

const useOfficialDailyDispatch = () => {
    const context = useContext(OfficialDailyContextDispatchContext);
    if (context === undefined) {
        throw new Error('useHomeDispatch must be used within a HomeProvider');
    }
    return context;
}

export { OfficialDailyProvider, useOfficialDailyState, useOfficialDailyDispatch, ACTION_TYPES };

